import React from "react";
import { Palette } from "lucide-react";

/** دليل جانبي للوقو: لوحة الألوان وملاحظات الاستخدام — يُعرض بجانب الأصل ولا يُرسم عليه */
export const BrandGuide = ({ guide }) => {
  if (!guide || !guide.palette?.length) return null;
  return (
    <div className="rounded-xl border border-border bg-secondary/40 p-3 text-xs space-y-2" data-testid="brand-guide">
      <div className="font-bold flex items-center gap-1"><Palette className="w-3.5 h-3.5 text-primary" /> دليل الاستخدام (جانبي — لا يظهر على اللوقو)</div>
      <div className="flex flex-wrap gap-2" data-testid="brand-guide-palette">
        {guide.palette.map((hx) => (
          <button key={hx} type="button" onClick={() => navigator.clipboard?.writeText(hx)} title="انسخ" className="flex items-center gap-1.5 rounded-full border border-border bg-background px-2 py-1" data-testid={`palette-${hx.slice(1)}`}>
            <span className="w-4 h-4 rounded-full border border-black/10" style={{ background: hx }} />
            <span className="font-mono">{hx}</span>
          </button>
        ))}
      </div>
      <ul className="list-disc ps-4 space-y-0.5 text-muted-foreground">{(guide.notes || []).map((n, i) => <li key={i}>{n}</li>)}</ul>
    </div>
  );
};
